function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

var Stack = function Stack(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(
    Wrapper,
    restProps,
    children
  );
};

export { Stack };
Stack.displayName = "Stack";

Stack.propTypes = process.env.NODE_ENV !== "production" ? {
  space: PropTypes.number
} : {};

Stack.defaultProps = {
  space: 1
};

var Wrapper = styled.div.withConfig({
  displayName: "Stack__Wrapper",
  componentId: "ma4vqp-0"
})(["display:grid;gap:", ";"], function (props) {
  return props.space + "rem";
});